const built = process.env.REACT_APP_BACKEND_URL;

// When the app is served from a domain other than the built-in backend URL
// (e.g. a custom production domain), call the API on the same origin —
// the ingress serves /api on every domain, and same-origin needs no CORS.
const resolve = () => {
  try {
    if (typeof window !== "undefined" && window.location.protocol.startsWith("http")
        && built && new URL(built).origin !== window.location.origin) {
      return window.location.origin;
    }
  } catch { /* fall through */ }
  return built;
};

export const BACKEND_URL = resolve();
